// @ts-nocheck

import React, { useContext } from 'react';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { Spinner, useToast } from '@chakra-ui/react';
import { CiImageOff } from 'react-icons/ci';

import CustomTagContext from 'hooks/useCustomTag';
import LoadContext from 'hooks/useLoad';
import { color } from 'styles/colors';
import SwitchToggle from 'components/SwitchToggleGeneral';
import { CustomTagProps } from 'types/CustomTagProps';
import { getTags } from 'modules/CustomTag/reqs';
import { deleteTag, activeTag } from './reqs';
import * as S from './styles';

export default function ListTags() {
  const { t } = useTranslation();
  const {
    tags,
    setTags,
    isReq,
    setIsEdit,
    setIsFormOpen,
    setItemToEdit,
    setPagesData,
    pagesData,
  } = useContext(CustomTagContext);

  const { setIsLoad } = useContext(LoadContext);
  const toast = useToast();

  // essa função retorna a pagina correta, ex: estou na pagina 3 e deletei o ultimo item, ai função retornará 2
  function adjustPageAfterDeletion(pagination: Pagination): number {
    const { limit, page, total } = pagination;
    return Math.max(1, Math.ceil((total - 1) / limit));
  }

  async function toggleItem(item: CustomTagProps) {
    const newItem = structuredClone(item);
    newItem.visible = !newItem.visible;

    setIsLoad(true);
    const isSuccess = await activeTag(newItem, newItem.id);
    setIsLoad(false);

    if (isSuccess) {
      setIsLoad(true);
      await getTags(setTags, setPagesData, pagesData.page);
      setIsLoad(false);
    }
  }

  async function deleteFunction(tag: CustomTagProps) {
    setIsLoad(true);
    const isSuccess = await deleteTag(tag, toast, t);
    setIsLoad(false);

    if (isSuccess) {
      setIsLoad(true);
      await getTags(setTags, setPagesData, adjustPageAfterDeletion(pagesData));
      setIsLoad(false);
    }
  }

  function editTag(tag: CustomTagProps) {
    setIsEdit(true);
    setIsFormOpen(true);
    setItemToEdit(tag);
  }

  return (
    <S.container>
      {!isReq && tags.length > 0 && (
        <S.listTag>
          {tags.map(item => (
            <S.tag key={item.id}>
              <S.colorDiv backColor={item.background_color} />

              <S.imagBox>
                {item?.file && item?.file !== null && item?.file?.url ? (
                  <img src={item.file.url} alt={item.text} />
                ) : (
                  <CiImageOff />
                )}
              </S.imagBox>

              <S.infosAndBtns>
                <S.infos>
                  <S.priority>
                    {`${t('customTags.priority')}:${item.priority}`}
                  </S.priority>
                  <div dangerouslySetInnerHTML={{ __html: item.text }} />
                  <S.clusterName>{item.vtex_cluster_name}</S.clusterName>
                </S.infos>
                <S.btns>
                  <SwitchToggle
                    isChecked={item.visible}
                    setIsChecked={() => toggleItem(item)}
                  />
                  <MdModeEdit
                    color={color.interface.darkgray3}
                    onClick={() => editTag(item)}
                  />
                  <MdDelete
                    color={color.system.error}
                    onClick={() => deleteFunction(item)}
                  />
                </S.btns>
              </S.infosAndBtns>
            </S.tag>
          ))}
        </S.listTag>
      )}

      {isReq && (
        <S.centralize>
          <Spinner size="md" color="#469bff" />
        </S.centralize>
      )}

      {!isReq && tags.length === 0 && (
        <S.noTags>
          <p>{t('customTags.thereIsNoTag')}</p>
        </S.noTags>
      )}
    </S.container>
  );
}
